export default {"src":"/_next/static/media/Indonesia.38c2a08d.svg","height":401,"width":320,"blurWidth":0,"blurHeight":0};